import React from "react";
import HeroSection from "../components/HeroSection";
import CalculatorSection from "../components/CalculatorSection";
import StoriesSection from "../components/StoriesSection";
import ProductHubSection from "../components/ProductHubSection";
import ComparisonSection from "../components/ComparisonSection";
import MythBusterSection from "../components/MythBusterSection";
import SafetyNetSection from "../components/SafetyNetSection";
import TrustSection from "../components/TrustSection";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Navbar />
      <main>
        <HeroSection />
        <CalculatorSection />
        <StoriesSection />
        <ProductHubSection />
        <ComparisonSection />
        <MythBusterSection />
        <SafetyNetSection />
        <TrustSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
